import { useNavigate, useLocation } from "react-router-dom";
import nexusLogo from "@/assets/nexus-logo.png";

interface LogoProps {
  isScrolled?: boolean;
}

const Logo = ({ isScrolled = false }: LogoProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogoClick = () => {
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
    }
  };

  return (
    <button 
      onClick={handleLogoClick}
      className="flex-shrink-0 cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 rounded"
      aria-label="Ir al inicio"
    >
      <img
        src={nexusLogo}
        alt="Nexus Logo"
        className={`w-auto transition-all duration-500 ease-out ${
          isScrolled 
            ? "h-6 md:h-7 grayscale opacity-70 scale-95" 
            : "h-7 md:h-8 grayscale-0 opacity-100 scale-100"
        }`}
        style={{
          transitionTimingFunction: isScrolled ? 'ease-in' : 'cubic-bezier(0.34, 1.56, 0.64, 1)'
        }}
       loading="lazy" decoding="async"/>
    </button>
  );
};

export default Logo;

